import { Field, ID, ObjectType } from 'type-graphql'

/** What the payroll and hauler tenant picker may read of a tenant: nothing beyond its id, code and name. */
@ObjectType()
export class TenantOption {
  @Field(() => ID)
  _id: string

  @Field(() => String)
  code: string

  @Field(() => String)
  name: string
}
